import { Link } from "react-router-dom";
import "./DropdownLinkItem.scss";
import Icon from "core/icon/Icon";
import PropTypes from "prop-types";

const DropdownLinkItem = ({
  id,
  children,
  deleteOption,
  onClick,
  onDelete,
  to,
  isContactSupportOption,
}) => {
  const handleClick = (event) => {
    if (!deleteOption && !isContactSupportOption && onClick) {
      onClick(event);
    }
  };

  return (
    <div className="dropdown-link-item-wrapper">
      {to ? (
        <Link
          to={to}
          onClick={handleClick}
          style={{ width: "100%" }}
          className="dropdown-link-item"
          id={id ? `dropdown_item_${id}` : undefined}
        >
          {children}
        </Link>
      ) : (
        <button
          onClick={handleClick}
          style={{
            width: "100%",
          }}
          className="dropdown-link-item button"
          id={id ? `dropdown_item_${id}` : undefined}
        >
          {children}
        </button>
      )}
      {deleteOption && (
        <Icon
          color="gray-200"
          icon="close"
          onClick={onDelete ? onDelete : undefined}
        />
      )}
    </div>
  );
};

DropdownLinkItem.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.any.isRequired,
  onDelete: PropTypes.func,
  deleteOption: PropTypes.bool,
  to: PropTypes.string,
  isContactSupportOption: PropTypes.bool,
};

DropdownLinkItem.defaultProps = {
  id: null,
  onClick: null,
  onDelete: null,
  deleteOption: false,
  isContactSupportOption: false,
};

export default DropdownLinkItem;
